export default {
	actions: {
		async apiRequest({commit, dispatch}, {method, endpoint, headers, body}) {
			let fetch_options = {
				method: method
			}

			if (headers == undefined) {
				headers = {}
			}

			if (body != undefined) {
				headers['content-type'] = 'application/json'
				fetch_options['body'] = JSON.stringify(body)
			}
			fetch_options['headers'] = headers

			try {
				var r = await fetch(`/internal${endpoint}`, fetch_options)
			} catch (e) {
				commit('showSnackbar', 'Ошибка связи с сервером')
				
				console.error('Ошибка API', e)
        throw e
			}

			if (r.status != 200) {
        r = await r.json()
        commit('showSnackbar', r.data.message)

        console.error(r.data)

				if (r.data.error_class == 'AuthorizationException') {
					await dispatch('userLogout')
				}
        
        let e = new Error(`(${r.data.error_class}) ${r.data.message}`)
        e.response = r

        throw e
      }

			return r
		},

		async apiRequestWithToken({dispatch, getters}, {method, endpoint, body}) {
			try {
				var r = await dispatch(
					'apiRequest', 
					{
						method: method,
						endpoint: endpoint,
						headers: { 'Token': getters.guestToken },
						body: body,
					}
				)
			} catch (e) {
				if (e.response.error_class == 'AuthorizationException') {
					dispatch('userLogout')
				}
				throw e
			}
			return r
		},

		async apiGuestRequest({ dispatch }, data) {
			const r = await dispatch('apiRequestWithToken', data)
			return (await r.json()).data
		}
	}
}